var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"anticon",attrs:{"aria-label":"icon"}},[_vm._t("default",function(){return [_c('img',{staticClass:"evericon",attrs:{"svg-inline":"","src":`@/app/shared/assets/evericons/${_vm.type}.svg`,"height":_vm.size,"width":_vm.size}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }